module.exports = __webpack_public_path__ + "static/img/stamp_03.b4f957b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_03.jpg
// module id = vrlf
// module chunks = 7